import { Cliente } from './cliente';
import { Produto } from './produto';
import { Telefone } from './telefone';
import { Endereco } from './endereco';
import { Grupo } from './grupo';

export class Cartao {

    private id: number;
    private uuid: string;
    private numero: string;
    private numeroReferencia: number;
    private documentoInicial: string;
    private nomeInicial: string;
    private emailInicial: string;
    private cliente: Cliente;
    private clienteId: number;
    private senha: string;
    private senhaEletronica: string;
    private sessionToken: string;
    private sessionValidity: string;
    private status: string;
    private indiceMoeda: number;
    private saldoPontos: number;
    private saldoPontosDevedor: number;
    private saldoPontosCancelamento: number;
    private produto: Produto;
    private nome: string;
    private sexo: string;
    private dataNascimento: string;
    private documento: string;
    private inscricaoEstadual: string;
    private inscricaoEstadualIsento: boolean;
    private telefoneResidencial: Telefone;
    private telefoneCelular: Telefone;
    private telefoneComercial: Telefone;
    private enderecoResidencial: Endereco;
    private dataAtualizacao: string;
    private dataImportacao: string;
    private dataCancelamento: string;
    private envioVirtualChave: number;
    private envioVirtualSenha: number;
    private grupos: Array<Grupo>;
    private dataUltimaTentativaLogin: string;
    private quantidadeTentativaLogin: number;
    private dataValidadeCampanha: string;
    private novaDataNascimento: string;
    private documentoValido: boolean;

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getUuid(): string {
        return this.uuid;
    }

    public setUuid(uuid: string): void {
        this.uuid = uuid;
    }

    public getNumero(): string {
        return this.numero;
    }

    public setNumero(numero: string): void {
        this.numero = numero;
    }

    public getNumeroReferencia(): number {
        return this.numeroReferencia;
    }

    public setNumeroReferencia(numeroReferencia: number): void {
        this.numeroReferencia = numeroReferencia;
    }

    public getDocumentoInicial(): string {
        return this.documentoInicial;
    }

    public setDocumentoInicial(documentoInicial: string): void {
        this.documentoInicial = documentoInicial;
    }

    public getNomeInicial(): string {
        return this.nomeInicial;
    }

    public setNomeInicial(nomeInicial: string): void {
        this.nomeInicial = nomeInicial;
    }

    public getEmailInicial(): string {
        return this.emailInicial;
    }

    public setEmailInicial(emailInicial: string): void {
        this.emailInicial = emailInicial;
    }

    public getCliente(): Cliente {
        return this.cliente;
    }

    public setCliente(cliente: Cliente): void {
        this.cliente = cliente;
    }

    public getClienteId(): number {
        return this.clienteId;
    }

    public setClienteId(clienteId: number): void {
        this.clienteId = clienteId;
    }

    public getSenha(): string {
        return this.senha;
    }

    public setSenha(senha: string): void {
        this.senha = senha;
    }

    public getSenhaEletronica(): string {
        return this.senhaEletronica;
    }

    public setSenhaEletronica(senhaEletronica: string): void {
        this.senhaEletronica = senhaEletronica;
    }

    public getSessionToken(): string {
        return this.sessionToken;
    }

    public setSessionToken(sessionToken: string): void {
        this.sessionToken = sessionToken;
    }

    public getSessionValidity(): string {
        return this.sessionValidity;
    }

    public setSessionValidity(sessionValidity: string): void {
        this.sessionValidity = sessionValidity;
    }

    public getStatus(): string {
        return this.status;
    }

    public setStatus(status: string): void {
        this.status = status;
    }

    public getIndiceMoeda(): number {
        return this.indiceMoeda;
    }

    public setIndiceMoeda(indiceMoeda: number): void {
        this.indiceMoeda = indiceMoeda;
    }

    public getSaldoPontos(): number {
        return this.saldoPontos;
    }

    public setSaldoPontos(saldoPontos: number): void {
        this.saldoPontos = saldoPontos;
    }

    public getSaldoPontosDevedor(): number {
        return this.saldoPontosDevedor;
    }

    public setSaldoPontosDevedor(saldoPontosDevedor: number): void {
        this.saldoPontosDevedor = saldoPontosDevedor;
    }

    public getSaldoPontosCancelamento(): number {
        return this.saldoPontosCancelamento;
    }

    public setSaldoPontosCancelamento(saldoPontosCancelamento: number): void {
        this.saldoPontosCancelamento = saldoPontosCancelamento;
    }

    public getProduto(): Produto {
        return this.produto;
    }

    public setProduto(produto: Produto): void {
        this.produto = produto;
    }

    public getNome(): string {
        return this.nome;
    }

    public setNome(nome: string): void {
        this.nome = nome;
    }

    public getSexo(): string {
        return this.sexo;
    }

    public setSexo(sexo: string): void {
        this.sexo = sexo;
    }

    public getDataNascimento(): string {
        return this.dataNascimento;
    }

    public setDataNascimento(dataNascimento: string): void {
        this.dataNascimento = dataNascimento;
    }

    public getDocumento(): string {
        return this.documento;
    }

    public setDocumento(documento: string): void {
        this.documento = documento;
    }

    public getInscricaoEstadual(): string {
        return this.inscricaoEstadual;
    }

    public setInscricaoEstadual(inscricaoEstadual: string): void {
        this.inscricaoEstadual = inscricaoEstadual;
    }

    public isInscricaoEstadualIsento(): boolean {
        return this.inscricaoEstadualIsento;
    }

    public setInscricaoEstadualIsento(inscricaoEstadualIsento: boolean): void {
        this.inscricaoEstadualIsento = inscricaoEstadualIsento;
    }

    public getTelefoneResidencial(): Telefone {
        return this.telefoneResidencial;
    }

    public setTelefoneResidencial(telefoneResidencial: Telefone): void {
        this.telefoneResidencial = telefoneResidencial;
    }

    public getTelefoneCelular(): Telefone {
        return this.telefoneCelular;
    }

    public setTelefoneCelular(telefoneCelular: Telefone): void {
        this.telefoneCelular = telefoneCelular;
    }

    public getTelefoneComercial(): Telefone {
        return this.telefoneComercial;
    }

    public setTelefoneComercial(telefoneComercial: Telefone): void {
        this.telefoneComercial = telefoneComercial;
    }

    public getEnderecoResidencial(): Endereco {
        return this.enderecoResidencial;
    }

    public setEnderecoResidencial(enderecoResidencial: Endereco): void {
        this.enderecoResidencial = enderecoResidencial;
    }

    public getDataAtualizacao(): string {
        return this.dataAtualizacao;
    }

    public setDataAtualizacao(dataAtualizacao: string): void {
        this.dataAtualizacao = dataAtualizacao;
    }

    public getDataImportacao(): string {
        return this.dataImportacao;
    }

    public setDataImportacao(dataImportacao: string): void {
        this.dataImportacao = dataImportacao;
    }

    public getDataCancelamento(): string {
        return this.dataCancelamento;
    }

    public setDataCancelamento(dataCancelamento: string): void {
        this.dataCancelamento = dataCancelamento;
    }

    public getEnvioVirtualChave(): number {
        return this.envioVirtualChave;
    }

    public setEnvioVirtualChave(envioVirtualChave: number): void {
        this.envioVirtualChave = envioVirtualChave;
    }

    public getEnvioVirtualSenha(): number {
        return this.envioVirtualSenha;
    }

    public setEnvioVirtualSenha(envioVirtualSenha: number): void {
        this.envioVirtualSenha = envioVirtualSenha;
    }

    public getGrupos(): Array<Grupo> {
        return this.grupos;
    }

    public setGrupos(grupos: Array<Grupo>): void {
        this.grupos = grupos;
    }

    public getDataUltimaTentativaLogin(): string {
        return this.dataUltimaTentativaLogin;
    }

    public setDataUltimaTentativaLogin(dataUltimaTentativaLogin: string): void {
        this.dataUltimaTentativaLogin = dataUltimaTentativaLogin;
    }

    public getQuantidadeTentativaLogin(): number {
        return this.quantidadeTentativaLogin;
    }

    public setQuantidadeTentativaLogin(quantidadeTentativaLogin: number): void {
        this.quantidadeTentativaLogin = quantidadeTentativaLogin;
    }

    public getDataValidadeCampanha(): string {
        return this.dataValidadeCampanha;
    }

    public setDataValidadeCampanha(dataValidadeCampanha: string): void {
        this.dataValidadeCampanha = dataValidadeCampanha;
    }

    public getNovaDataNascimento(): string {
        return this.novaDataNascimento;
    }

    public setNovaDataNascimento(novaDataNascimento: string): void {
        this.novaDataNascimento = novaDataNascimento;
    }

    public isDocumentoValido(): boolean {
        return this.documentoValido;
    }

    public setDocumentoValido(documentoValido: boolean): void {
        this.documentoValido = documentoValido;
    }

}



// WEBPACK FOOTER //
// ./src/app/resources/classes/cartao.ts